
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqR4U_64u_451X8x3nYF2mFG9pgQu0I2x5KrcQ6HfGKX46YMeta } from "/codebuild/output/src1837513527/src/src/pages/faq.vue?macro=true";
import { default as menuE8OucAWfGWJC_gnf9kzKP2fk7TA8CwamlP2KB5skqHEMeta } from "/codebuild/output/src1837513527/src/src/pages/menu.vue?macro=true";
import { default as indexuuC6wczNKLW6yT1_45HNMJrwcJVstbpbDqDSxfPg6nFkcMeta } from "/codebuild/output/src1837513527/src/src/pages/index.vue?macro=true";
import { default as contactda0IH_KdY5Z2Kew6F7qifA5Ghc9bQt2lrHgvB_45gtywwMeta } from "/codebuild/output/src1837513527/src/src/pages/contact.vue?macro=true";
import { default as tutorialeAzBLS8a4wcVKUbFRvPpXQEUH8sn8fd9GVXvBjQdUKQMeta } from "/codebuild/output/src1837513527/src/src/pages/tutorial.vue?macro=true";
import { default as agreement1ug8z15WgsFtIViKI2MF0ZGdtxooZeez1GpRlsoIVSMMeta } from "/codebuild/output/src1837513527/src/src/pages/agreement.vue?macro=true";
import { default as about_45passyVsZNJ5HI2pXdVzpBDZoadTQdzdZ4_g5_IfMJ_7wVwAMeta } from "/codebuild/output/src1837513527/src/src/pages/about-pass.vue?macro=true";
import { default as indexPejqt4olZBTRwbueVhpl_RM4s69jkqoNW1Ug870OeaQMeta } from "/codebuild/output/src1837513527/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93i7SR3YYWyt6NCn8c4pWtoYcWHBwTH10SU8aGPUD8fZYMeta } from "/codebuild/output/src1837513527/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancel0Is9C3CSHvqawFrIjL1yLUFlxVMsMKpmexkTFTFhP4Meta } from "/codebuild/output/src1837513527/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93FvHntz4RZ2opolHlh9VSysKlBk6AcHq9_7g50askhzYMeta } from "/codebuild/output/src1837513527/src/src/pages/notice/[id].vue?macro=true";
import { default as index8Lf9beRL0B_x12H2upGQIBn3x00TAhk0awm2sTTrIVYMeta } from "/codebuild/output/src1837513527/src/src/pages/coupon/index.vue?macro=true";
import { default as indexxbKJNbxo2kSnCNwBRXptW_45xYT8fOp70IPO25btsDrB0Meta } from "/codebuild/output/src1837513527/src/src/pages/mypage/index.vue?macro=true";
import { default as indexazz80y7_45g6KZbEJkqjytpYbV5gW7othwMlkDDoRKdkoMeta } from "/codebuild/output/src1837513527/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93eiCGmYK9v6XAFxeqTQRHANu_xtiOAkizcPS_45CvMtMhsMeta } from "/codebuild/output/src1837513527/src/src/pages/parking/[id].vue?macro=true";
import { default as indexv6vTM4y1H4Qx6NT9pmU6ZClWost3ApfeeP4NfwOmiH8Meta } from "/codebuild/output/src1837513527/src/src/pages/history/index.vue?macro=true";
import { default as indexcmOcuZBVkEUUmK_iPsRlIkF5c6q_5zdFzIuV0oxHHloMeta } from "/codebuild/output/src1837513527/src/src/pages/monthly/index.vue?macro=true";
import { default as indexWhackds5MeaxNxAIVJumf3YjgS23gsAwXuFQJKsuVt8Meta } from "/codebuild/output/src1837513527/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexZs37pMTJmLdGstp82vZZS5sjsTdtrh3OpvFNoLQOnOkMeta } from "/codebuild/output/src1837513527/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavijvyXVw1G1oGeXiL33yqTK6A1a7ZR5YrksScZXfjT0u4Meta } from "/codebuild/output/src1837513527/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editPPuj6ucU76Gdlc_c50edi6Pkw7LUtVtRLCRXkVx4KvAMeta } from "/codebuild/output/src1837513527/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementKFlWqlLChewt2tMMD339LyyZ4at30BRCl5f8ZEtDm4UMeta } from "/codebuild/output/src1837513527/src/src/pages/pass-agreement.vue?macro=true";
import { default as index3TsQKYl1r3urskJAiX__kC_45tR7K_45D1apED1DNrcEZVEMeta } from "/codebuild/output/src1837513527/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dn2WteJjPUHc26lZwZNmVqnrB0oQTXDFyEHkA57mBbTMMeta } from "/codebuild/output/src1837513527/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmNekZbpEZy2Ea9BQk5DkDr7xjwUZBnSrmFtEBKQwR4Y4Meta } from "/codebuild/output/src1837513527/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index4g8LmhvbHbj9dToKQg7Ik8bNTKp7DMRIFpB_4522Kh1q8Meta } from "/codebuild/output/src1837513527/src/src/pages/card/create/index.vue?macro=true";
import { default as indexy3QBobSjFELdgf_45M8fPUQ5huS_vpLXcCdkPXR3lwjGMMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmDsJJxwnOWt6H_ja78gP0CUd9WdfB06RSifBdTAGooHYMeta } from "/codebuild/output/src1837513527/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmMy_45ez7PIQD_0FAvDLmIVXY8dtCY7k4B1XCRxqzL2M6IMeta } from "/codebuild/output/src1837513527/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeM8PNIUK6X4OjDA5Pkucb27EjsI_45uSEnxf895348zYiIMeta } from "/codebuild/output/src1837513527/src/src/pages/membership/complete.vue?macro=true";
import { default as registerp4nhW8asg6SMX48ytzwqMExWsBXyVZVssHxfAOZksFMMeta } from "/codebuild/output/src1837513527/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93t21fdgYH8B_3_3X5TRN7Sm7pZl_gvThsPNSQwyJ3q7EMeta } from "/codebuild/output/src1837513527/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmm1h0synFhew6WHGHWMRxCnn2_5HRMmZymmSi3ZqP_QAMeta } from "/codebuild/output/src1837513527/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93Zj8OpQdDiV4RcA9q_SDj1z1wMA3mhlkfwtEVQ3tP5AEMeta } from "/codebuild/output/src1837513527/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index5I9ukrbCh0fMZXuiWjlT8S4yjNU9WsGusT5mFoNQjG8Meta } from "/codebuild/output/src1837513527/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeS94Dvj3QVqb2EzBfG07Na9SI2XJdg5i78VnvB2mUXUcMeta } from "/codebuild/output/src1837513527/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeEn3km_45vDRYK90VlwZ2XJ3mfF_45uxZYc1VS6PckHJJY3YMeta } from "/codebuild/output/src1837513527/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeUcd2qA7KhglbhdlE7AFc_45Dt3w_TKJlASGZOD9_XmfG8Meta } from "/codebuild/output/src1837513527/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registercTtqOtzZlvvtXO_Y18Hm3dMo3SrqHC2TcgcW0qJeDN0Meta } from "/codebuild/output/src1837513527/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete72Imrrq0QmvwqKJqsbMxinfi3R5krgYpw7gADZ8mNTYMeta } from "/codebuild/output/src1837513527/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexiBQSmlUPya2V9nhva9f88i96AeDBCuyY_45nJgpegBuPwMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmOy7do76NU52XBq24fmmWSIeK2cBxQ4B4ve5qClz6fHkMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete7HClDHkLMztAdylIwZZF2RvquC9XMtft1PemvT29_45eYMeta } from "/codebuild/output/src1837513527/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexQyrgFGCP1EA_NpBchGAerkG_YaDupZEOVo1NkE8W_foMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93HXTXEa8Ke1cDeToZHd1ysJ4EBm8tkN9VGMRG_45RqtMTwMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeX2B9VSX57V37tX_F8tba8kGAwzNoiHX_45vGpBHCwoDe4Meta } from "/codebuild/output/src1837513527/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasPkPTcURZ9GJKVzc00uCqswdEh1QNgU1XAStFUt0Se8EMeta } from "/codebuild/output/src1837513527/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplePGL1b44XK_45JqDEQKuEJyeiiSVp7jPez9DDtPaw8ibSMMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailSOkb0C0Rwp4vUHcep_45O_QRuznyWyASIuGhacFqbRSnsMeta } from "/codebuild/output/src1837513527/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm_Y1uPhSiFDkCybiOmhwlM7I7ZBXnaZDtsAawwsbVg_sMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentsgITx8mFv_4PTAdasGCYW_455dcANk_45Xm226neYoYh0ZkMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmxxX6OlKi24K_45S_YRS8CFQH3tnXc7gOKRGesB1CgbNmAMeta } from "/codebuild/output/src1837513527/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateEm1quRXAW9uW2Nx6KBplzAP_4wwJLTKmVJu_Rcj1mrMMeta } from "/codebuild/output/src1837513527/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeqXkOLoLmz_45dnBNA3L3dvotqK2faGYTpmHIWaqu73tbEMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code1KFK6aVxyXC1X_45g0VaV3LK5Ypa8cpv6lEP1_Vd32IHgMeta } from "/codebuild/output/src1837513527/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password5oyrTj_ot9nSlu2sfhvq3BAqdEHFeIKw2VYTvQQZPWEMeta } from "/codebuild/output/src1837513527/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasPlkHnruHkZ0xEivA09abWCkKuIjqXhvGAZZbbV2I_45RYMeta } from "/codebuild/output/src1837513527/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register8yBUzbzEUlntPcQjrirjygigpEsxKxCl9WnPSG_oQ_4Meta } from "/codebuild/output/src1837513527/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code0asmd_Y7nhQYYJSxR_45hq8QZLFmNTjCR47_cATM0E8mQMeta } from "/codebuild/output/src1837513527/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index8z8feequK3DkiHPKMnjr_459ni_l8NrqwG_45MyNvqWXNTcMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexu05BPW4db_45v6zuDX93xxACLYkk6dMWhqffguDZmgrD4Meta } from "/codebuild/output/src1837513527/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexUMcuj9e_xJdHJcSq05hqRcOUIF9syWET4MK1xq_45w9Y8Meta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexWOkoNHBhOXkH4LhUkNXeaZ4aWgrodBsw9MivF3RhrHUMeta } from "/codebuild/output/src1837513527/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateEuhHXkct31qf4VECuIJPiVhrureFqZNEWGaPTBNROFkMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completenNLDOF4HmfUD_9XAAY31SV99sMUeZYW_5wBBkUbykAQMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmu34NiqzxO8QzG_45GZy4PxBcrD6O4he1E8vbIZCHDnvZYMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexUUkzgXGU1ZUQTFNY7xu5ybj6ZD9Xq55q_45BX8S94JU5oMeta } from "/codebuild/output/src1837513527/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completesvv3boQNr80GC_5F0e5HTSku9tQ_45cOTLrhu3qpwIX3wMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update5kn5Uy4M2O_mrqdlG5w_16IEucRMeFpIK7Am6C4pLBoMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index0BCA0lcsgR4vu3qEYaKYHUHutJR85WGR1ryedMTYwUMMeta } from "/codebuild/output/src1837513527/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexDIs8JHNdN9qKyWXJcE7wm2Uh3A0SXMtQngEJKZ6O_45H8Meta } from "/codebuild/output/src1837513527/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completegckSdUusXCpM3dkq9BuwTWx2qJvi7ne3bifefYTn8gIMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index_3BxQbNi_2l2SimX09nmlhkx0AgFmWmeB5_45emjcdihEMeta } from "/codebuild/output/src1837513527/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeIQATb0H32OAg1wNewqQuKEViO6JveAsPMEpAvI5hPvIMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexnhumPK7FFDnIkhgDYBvupjbWxTD91NVMDIicP35VkGoMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexrunHlnwne9bAPX64Wwmc0pqWWbLRsJ_45a6YEFI83oDKoMeta } from "/codebuild/output/src1837513527/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexCnu9crTxs5M5fAHiB6wuIbDCs5vT0gxnEiU4G_45eJWNsMeta } from "/codebuild/output/src1837513527/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update9zD77g0u0DQE7DxB15Sdd04bTmstMY7zcsQd3rg7ZHwMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmBQlkwm8mTsbLcWe_LmubQkSPGm_45lspI_45_45aanw8DHR_45kMeta } from "/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuE8OucAWfGWJC_gnf9kzKP2fk7TA8CwamlP2KB5skqHEMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexuuC6wczNKLW6yT1_45HNMJrwcJVstbpbDqDSxfPg6nFkcMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1837513527/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index8Lf9beRL0B_x12H2upGQIBn3x00TAhk0awm2sTTrIVYMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1837513527/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexv6vTM4y1H4Qx6NT9pmU6ZClWost3ApfeeP4NfwOmiH8Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1837513527/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexWhackds5MeaxNxAIVJumf3YjgS23gsAwXuFQJKsuVt8Meta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexZs37pMTJmLdGstp82vZZS5sjsTdtrh3OpvFNoLQOnOkMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index4g8LmhvbHbj9dToKQg7Ik8bNTKp7DMRIFpB_4522Kh1q8Meta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmDsJJxwnOWt6H_ja78gP0CUd9WdfB06RSifBdTAGooHYMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmMy_45ez7PIQD_0FAvDLmIVXY8dtCY7k4B1XCRxqzL2M6IMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1837513527/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeM8PNIUK6X4OjDA5Pkucb27EjsI_45uSEnxf895348zYiIMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerp4nhW8asg6SMX48ytzwqMExWsBXyVZVssHxfAOZksFMMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmm1h0synFhew6WHGHWMRxCnn2_5HRMmZymmSi3ZqP_QAMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeS94Dvj3QVqb2EzBfG07Na9SI2XJdg5i78VnvB2mUXUcMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeEn3km_45vDRYK90VlwZ2XJ3mfF_45uxZYc1VS6PckHJJY3YMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeUcd2qA7KhglbhdlE7AFc_45Dt3w_TKJlASGZOD9_XmfG8Meta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registercTtqOtzZlvvtXO_Y18Hm3dMo3SrqHC2TcgcW0qJeDN0Meta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmOy7do76NU52XBq24fmmWSIeK2cBxQ4B4ve5qClz6fHkMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete7HClDHkLMztAdylIwZZF2RvquC9XMtft1PemvT29_45eYMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexQyrgFGCP1EA_NpBchGAerkG_YaDupZEOVo1NkE8W_foMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeX2B9VSX57V37tX_F8tba8kGAwzNoiHX_45vGpBHCwoDe4Meta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplePGL1b44XK_45JqDEQKuEJyeiiSVp7jPez9DDtPaw8ibSMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailSOkb0C0Rwp4vUHcep_45O_QRuznyWyASIuGhacFqbRSnsMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm_Y1uPhSiFDkCybiOmhwlM7I7ZBXnaZDtsAawwsbVg_sMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentsgITx8mFv_4PTAdasGCYW_455dcANk_45Xm226neYoYh0ZkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmxxX6OlKi24K_45S_YRS8CFQH3tnXc7gOKRGesB1CgbNmAMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeqXkOLoLmz_45dnBNA3L3dvotqK2faGYTpmHIWaqu73tbEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code1KFK6aVxyXC1X_45g0VaV3LK5Ypa8cpv6lEP1_Vd32IHgMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password5oyrTj_ot9nSlu2sfhvq3BAqdEHFeIKw2VYTvQQZPWEMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register8yBUzbzEUlntPcQjrirjygigpEsxKxCl9WnPSG_oQ_4Meta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code0asmd_Y7nhQYYJSxR_45hq8QZLFmNTjCR47_cATM0E8mQMeta || {},
    component: () => import("/codebuild/output/src1837513527/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1837513527/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]